import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'withRouter'
import ProcessPage from 'components/ProcessPage';
import ConfirmationElement, { ICON } from '../ConfirmationElement';
import SsoPage from '../SSO/SsoPage';
import { routeMapping } from 'routes';
import { VuiButton } from '@topkamera/viso-ui';

class ConfirmationPage extends Component {
  onBackToLogin = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }

    this.props.router.navigate(routeMapping.LOGIN.path);
  };

  render() {
    const {
      title = 'Please verify your email', description = 'Please check your inbox', icon, buttonLabel = 'Back to Login', footerText, footerLinkUrl, footerLinkText, color
    } = this.props;

    return (
      <ProcessPage splitPage={true}>
        {() => (
          <div>
            <SsoPage
              title={title}
              description={description}
            >
              <div className='sso-page-form vui-pt-20'>
                <div className='sso-page-form__field sso-page-form__field--margin-md vui-flex vui-justify-center'>
                  <div className="sso-page-form__button">
                    <div className="vui-mb-28 vui-pb-2">
                      <ConfirmationElement icon={ICON[icon]} color={color} />
                    </div>
                    <VuiButton
                      onClick={this.onBackToLogin}
                      color='accent0'
                      style='filled'
                      radius='pill'
                      label={buttonLabel}
                      isBlock
                    />
                  </div>
                </div>
                {(footerText || footerLinkText) &&
                  <div className="sso-page-form__helper">
                    {footerText}
                    {' '}
                    <a href={footerLinkUrl} className="vui-text-accent0">
                      {footerLinkText}
                    </a>
                  </div>
                }
              </div>
            </SsoPage>
          </div>
        )}
      </ProcessPage>
    );
  }
}

ConfirmationPage.propTypes = {
  isLoading: PropTypes.bool,
  handleSubmit: PropTypes.func,
  currentPage: PropTypes.string,
};

export default withRouter(ConfirmationPage);